import { useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useBreadcrumb } from "../../../contexts/BreadcrumbContext.jsx";
import CustomersTable from "../../../components/tables/CustomersTable.jsx";

export default function CustomerIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Kunden", path: "/admin/kunden" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <CustomersTable
        pageTitle="Kundenverwaltung"
        pageSubtitle="Übersicht aller Kunden"
        onRowClick={(customer) => {
          if (!customer || !customer.id) {
            return;
          }
          navigate(`/admin/kunden/${customer.id}`);
        }}
      />
    </Box>
  );
}
